import { CALENDAR, LEFT, RIGHT } from "icons";
import { Button } from "ui/components/button";
import Icon from "../icon";
import React from "react";
import HeaderPortal from "components/portal/header-portal"

/**
 * Calendar header component with month navigation and view selection
 *
 * @param {Object} props
 * @param {Date} props.currentDate - Current displayed date
 * @param {function} props.onPrevMonth - Handler for previous month button
 * @param {function} props.onNextMonth - Handler for next month button
 * @param {function} props.onToday - Handler for Today button
 * @param {string} props.currentView - Current calendar view
 * @param {function} props.onViewChange - Handler for view change
 * @param {function} props.onAddEvent - Handler for add event button
 * @param {function} [props.renderHeader] - Custom header renderer
 * @param {string} [props.locale='en-US'] - Locale for date formatting
 */
const CalendarHeader = ({
  currentDate,
  onPrevMonth,
  onNextMonth,
  onToday,
  currentView,
  onViewChange,
  onAddEvent,
  renderHeader,
  locale = "en-US",
  isHeaderPortal,
}) => {

  if (renderHeader) {
    return renderHeader({
      currentDate,
      onPrevMonth,
      onNextMonth,
      onToday,
      currentView,
      onViewChange,
      onAddEvent,
    });
  }

  // Get formatted month and year
  const month = currentDate.toLocaleString(locale, { month: "long" });
  const year = currentDate.getFullYear();

  if (isHeaderPortal) {
    return (
      <HeaderPortal className="order-1">
        <div className="relative flex gap-2 items-center justify-between   rounded-md bg-white  md:items-stretch ">
          <Button variant="outline" onClick={onPrevMonth} size="icon">
            <span className="sr-only">Previous month</span>

            <Icon icon={LEFT} className="size-4" aria-hidden="true" />
          </Button>
          <Button variant="outline" className="" onClick={onToday}>
            <Icon icon={CALENDAR} /> {`${month}, ${year}`}
          </Button>
          {/* </Button> */}
          <span className="relative -mx-px h-5 w-px bg-gray-300 md:hidden" />
          <Button variant="outline" onClick={onNextMonth} size="icon">
            <span className="sr-only">Next month</span>
            <Icon icon={RIGHT} className="size-4" aria-hidden="true" />
          </Button>
        </div>
      </HeaderPortal>
    );
  }
  return (
    <header className="flex items-center justify-between px-6 py-6 lg:flex-none">
      <div className="flex items-center">
        <HeaderPortal className="order-1">
          <div className="relative flex gap-2 items-center justify-between   rounded-md bg-white shadow-xs md:items-stretch ">
            <Button variant="outline" onClick={onPrevMonth} size="icon">
              <span className="sr-only">Previous month</span>

              <Icon icon={LEFT} className="size-4" aria-hidden="true" />
            </Button>
            <Button variant="outline" className="" onClick={onToday}>
              <Icon icon={CALENDAR} /> {`${month}, ${year}`}
            </Button>
            {/* </Button> */}
            <span className="relative -mx-px h-5 w-px bg-gray-300 md:hidden" />
            <Button variant="outline" onClick={onNextMonth} size="icon">
              <span className="sr-only">Next month</span>
              <Icon icon={RIGHT} className="size-4" aria-hidden="true" />
            </Button>
          </div>
        </HeaderPortal>
      </div>
    </header>
  );
};

export default CalendarHeader;
